import { useMemo } from 'react';
import { useStore, useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { selectors } from '~/store/state-selectors';
export const useServiceNameOptions = ()=>{
    const { api } = useStoreActions();
    const isVendor = useStore(selectors.user.isVendor);
    const businessId = useStore(selectors.user.businessId);
    const { data } = useQueryState({
        queryKey: [
            QueryKeys.RelationshipServiceNames,
            businessId,
            isVendor
        ],
        queryFn: ()=>api.relationship.getServiceNames(businessId !== null && businessId !== void 0 ? businessId : '', isVendor, 'proposal'),
        enabled: businessId != null
    });
    return useMemo(()=>(data !== null && data !== void 0 ? data : []).map((name)=>({
                id: name,
                name,
                body: '',
                isBundle: false
            })), [
        data
    ]);
};
